import {EntityService} from '../../../service/EntityService';

/** Payload GET .../business-location/register-invoice/:id (địa điểm kinh doanh) */
export interface RegisterInvoiceBusinessLocation {
  id?: string;
  code?: string | null;
  name?: string | null;
  address?: string | null;
  active?: boolean;
  creationTime?: string;
  creatorId?: string;
  lastModificationTime?: string;
  lastModifierId?: string;
}

export class BusinessLocationService extends EntityService {

  static entity = 'app/business-location';

  static getBusinessLocation(registerInvoiceId: string): Promise<RegisterInvoiceBusinessLocation> {
    return this.axios
      .get(`${this.entity}/register-invoice/${registerInvoiceId}`)
      .then(res => res.data);
  }

}
